function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    width: "100%",
    height: "100%",
    viewBox: "0 0 204 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "left-3",
    d: "M134.925,62.622c-38.627,-10.838 -81.168,-24.122 -118.083,-14.467c-5.59,1.462 -10.932,3.193 -15.91,5.403l0,18.796c1.076,-0.549 2.148,-1.098 3.244,-1.627c38.767,-18.727 87.098,-12.393 130.749,-8.105",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-1",
    d: "M134.509,17.806c-38.627,-10.838 -81.168,-24.122 -118.083,-14.467c-5.434,1.422 -10.631,3.105 -15.491,5.229l-0,18.761c0.937,-0.477 1.87,-0.955 2.826,-1.417c38.766,-18.728 87.097,-12.394 130.748,-8.106",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "left-2",
    d: "M134.718,40.165c-38.627,-10.838 -81.17,-24.121 -118.084,-14.467c-5.512,1.44 -10.781,3.148 -15.699,5.314l0,18.78c1.007,-0.512 2.008,-1.025 3.035,-1.521c38.766,-18.728 87.095,-12.393 130.748,-8.106",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-1",
    d: "M203.607,7.794c-1.18,0.608 -2.365,1.211 -3.574,1.794c-38.77,18.729 -87.098,12.393 -130.75,8.107c38.625,10.838 81.167,24.121 118.083,14.467c5.711,-1.493 11.17,-3.263 16.24,-5.544l-0,-18.824l0.001,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-3",
    d: "M203.607,52.819c-1.047,0.535 -2.09,1.069 -3.156,1.588c-38.77,18.728 -87.1,12.393 -130.751,8.106c38.625,10.837 81.167,24.12 118.083,14.464c5.559,-1.451 10.871,-3.175 15.824,-5.369l-0,-18.789Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-2",
    d: "M203.607,30.355c-1.115,0.572 -2.229,1.14 -3.367,1.69c-38.768,18.729 -87.097,12.392 -130.749,8.106c38.627,10.838 81.168,24.121 118.083,14.47c5.639,-1.477 11.023,-3.224 16.033,-5.459l-0,-18.807Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "andel-text"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.939,128.632l0,-37.264l-9.77,0l0,45.464l25.604,0l0,-8.2l-15.834,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.216,99.501l2.613,-8.133l-26.646,0l0,45.465l26.49,0l0,-8.133l-16.652,0l0,-10.976l14.332,0l0,-8.201l-14.332,0l0,-10.022l14.195,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.964,91.368l-15.189,0l-0,45.464l14.371,0c15.86,0 26.108,-9.069 26.108,-23.106c-0.001,-13.999 -9.454,-22.358 -25.29,-22.358m-0.479,37.264l-4.875,0l0,-28.994l4.738,0c9.778,0 15.385,5.233 15.385,14.36c0.001,9.163 -5.701,14.634 -15.248,14.634",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.167,114.545c-0,1.735 -0,4.27 0.099,6.308c-1.173,-1.745 -2.323,-3.372 -3.896,-5.367l-18.836,-24.022l-0.073,-0.095l-9.78,0l-0,45.465l9.77,0l-0,-24.884c-0,-1.747 -0,-4.055 -0.09,-5.624c1.189,1.721 2.361,3.396 3.953,5.434l19.52,24.979l0.072,0.094l9.03,0l-0,-45.465l-9.769,0l-0,23.177Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.797,91.164l-17.668,45.335l-0.129,0.333l9.739,0l2.617,-7.06l18.146,0l2.719,7.06l10.562,0l-18.557,-45.668l-7.429,0Zm3.616,13.646c0.322,1.275 0.83,2.8 1.441,4.633l4.387,12.028l-11.826,0l4.551,-12.165c0.531,-1.444 1.097,-3.062 1.447,-4.496",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2023);
export default __webpack_public_path__ + "static/media/logo2023.74c354f489879bb0def460998218c662.svg";
export { ForwardRef as ReactComponent };